import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
  imports: [ToastModule],
  selector: 'app-toast',
  templateUrl: './app-toast.component.html',
})
export class AppToastComponent {
  private static icons: Record<string, string> = {
    success: 'pi-check',
    info: 'pi-info-circle',
    warning: 'pi-exclamation-triangle',
    error: 'pi-times-circle',
  };

  getIconClass(severity?: string | null) {
    const icon = AppToastComponent.icons[severity ?? 'info'];
    return `pi ${icon}`;
  }
}
